import { useNavigate } from "react-router-dom";
import "./NavigateButton.css"; // Assuming you have a CSS file for styling

export default function NavigateButton(props) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate("/products", { state: { cat: props.cat } })}
      className="navigate-btn"
      aria-label="Next"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="9 6 15 12 9 18" />
      </svg>
    </button>
  );
}
